/**
 * Check whether an index is the last index in array.
 */
export const isLastItem = (list: any[], index: number) => index + 1 === list.length;
